<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todas las campañas</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="180px" prop="name" sortable> </el-table-column>

        <el-table-column label="Estado" min-width="150px" prop="active">
          <template #default="{ row }">
            <div>
              <strong>{{ row.active ? 'Activa' : 'Inactiva' }}</strong>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Fecha Desde" min-width="150px" prop="from">
          <template #default="{ row }">
            <div>{{ row.from | date }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Fecha Hasta" min-width="150px" prop="to">
          <template #default="{ row }">
            <div>{{ row.to | date }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Cultivo" min-width="120px" prop="crop">
          <template #default="{ row }">
            <div v-for="crop in row.crops" :key="crop.id">
              <small>{{ crop.name }}</small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Acciones" min-width="120px" prop="crop">
          <template #default="{ row }">
            <div>
              <div v-if="$can('update', 'campaigns')">
                <button
                  v-if="row.active"
                  class="btn base-button btn-outline-warning btn-sm mt-1"
                  @click="disableCampaing(row.id)"
                >
                  <i class="fas fa-ban"></i>
                </button>
                <button v-else class="btn base-button btn-outline-success btn-sm mt-1" @click="enableCampaign(row.id)">
                  <i class="fas fa-check"></i>
                </button>

                <router-link
                  :to="{ name: 'CampaignEdit', params: { id: row.id } }"
                  class="btn base-button btn-outline-primary btn-sm mt-1"
                >
                  <i class="fas fa-pen"></i>
                </router-link>

                <router-link
                  v-if="$can('index', 'campaign_dates')"
                  :to="{ name: 'CampaignDates', params: { id: row.id } }"
                  class="btn base-button btn-outline-success btn-sm mt-1"
                >
                  <i class="fas fa-calendar-alt"></i>
                </router-link>
              </div>

              <button
                v-if="$can('destroy', 'campaigns')"
                class="btn base-button btn-outline-danger btn-sm"
                @click="deleteRow(row.id)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} campañas</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';

export default {
  name: 'CampaignsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin, DeleteRowFromTableMixin],
  data() {
    return {
      searchKeys: ['name', 'from', 'to', 'crops.name'],
      tableData: [],
      tableName: 'CampaignsTable',
    };
  },

  created() {
    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará la campaña';
    this.alertSuccessSettings.message = 'La campaña ha sido eliminada';
    this.resourceName = 'campaigns';
  },

  mounted() {
    this.$services
      .resource('campaigns')
      .get({ include: 'crops' })
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.campaigns));
  },

  methods: {
    enableCampaign(campaignId) {
      const status = { active: true };
      this.$services
        .resource('campaigns')
        .update(campaignId, status)
        .then((res) => res.data.data)
        .then(() => {
          this.updateRow(campaignId, status);
        });
    },

    disableCampaing(campaignId) {
      const status = { active: false };
      this.$services
        .resource('campaigns')
        .update(campaignId, status)
        .then((res) => res.data.data)
        .then((data) => {
          this.updateRow(campaignId, status);
        });
    },

    updateRow(id, payload) {
      const index = this.tableData.findIndex((id) => +campaign.id === +id);
      Object.assign(this.tableData[index], payload);
    },
  },
};
</script>
